import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Float() {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('RV');
    const [show, setShow] = useState(true);

    const handleClose = (e: any) => {
        // e.stopPropagation();
        e.preventDefault();
        setShow(false);
    };

    const handleClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: t('float').replace('\n', ' '),
        });
        return true;
    };

    return (
        <>
            {show && (
                <div className={`float ${css['float']}`}>
                    <a href={'#RV-A'} className="float-link" onClick={handleClick}>
                        <div className="float-img">
                            <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717081702826/float.png'} alt={t('float')} />
                        </div>
                        <p className="float-text">{t('float')}</p>
                        <svg
                            className="float-close"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            onClick={handleClose}
                        >
                            <circle cx="7" cy="7" r="7" fill="#999999" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9.23103 5.27123C9.43605 5.06621 9.43605 4.73379 9.23103 4.52877C9.026 4.32374 8.69359 4.32374 8.48857 4.52877L6.88011 6.13723L5.27165 4.52877C5.06663 4.32374 4.73422 4.32374 4.52919 4.52877C4.32417 4.73379 4.32417 5.06621 4.52919 5.27123L6.13765 6.87969L4.52877 8.48857C4.32374 8.69359 4.32374 9.026 4.52877 9.23103C4.73379 9.43605 5.06621 9.43605 5.27123 9.23103L6.88011 7.62215L8.48899 9.23103C8.69402 9.43605 9.02643 9.43605 9.23145 9.23103C9.43648 9.026 9.43648 8.69359 9.23145 8.48857L7.62257 6.87969L9.23103 5.27123Z"
                                fill="white"
                            />
                        </svg>
                    </a>
                </div>
            )}
        </>
    );
}
